module.exports = __webpack_public_path__ + "static/scale-model-of-six-flags-hurricane-harbor-in-arlington-texas-77a24966808b075296551d66d18e3463.png";